module.exports = {
  SectionsContainer: require('./dist/SectionsContainer').default,
  Section: require('./dist/Section').default,
  ScrollToTopOnMount: require('./dist/ScrollToTopOnMount').default,
  Header: require('./dist/Header').default,
  Footer: require('./dist/Footer').default,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-fullpage/index.js
// module id = 132
// module chunks = 6